<script lang="ts" setup>
    import { ref, computed } from 'vue'

    const props = defineProps({
        literatur: {
            type: String,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() =>
        props.language === 'englisch' ? 'Literature | Literatur' : 'Literatur'
    )

    const emit = defineEmits(['literaturSaved'])

    let editLiteratur = ref('')

    function handleEditStart() {
        editLiteratur.value = props.literatur
    }

    function handleEditAbort() {
        editLiteratur.value = ''
    }

    const saveLiteratur = () => {
        emit('literaturSaved', editLiteratur.value)
    }
</script>

<template>
    <common-single-edit
        :entry="literatur"
        edit-key="literatur"
        :title="title"
        :tool-tip="tooltip"
        :allow-edit="allowEdit"
        @text-saved="saveLiteratur"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
    >
        <template #edit-component>
            <common-my-markup-editor v-model:content="editLiteratur" />
        </template>
        <template #preview-component>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="literatur" />
        </template>
    </common-single-edit>
</template>

<script></script>

<style scoped lang="scss"></style>
